import React from 'react';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import authActions from '../../Restore/redux/auth/actions';
import cookieHelper from '../../Restore/library/helpers/cookieHelper';

const NoAccess = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(authActions.logout());
    history.push('/signin');
  };

  const handleContactAdmin = () => {
    const userDetails = cookieHelper.getUserDetails();
    // You can customize this to open a contact form, email, or support ticket
    window.location.href = 'mailto:admin@jivahealth.com?subject=Access Request&body=Hello, I need access to the dashboard. My staff ID is: ' + 
      (userDetails?.staffId || 'N/A');
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#f5f5f5'
    }}>
      <Result
        status="403"
        title="Access Denied"
        subTitle="You don't have permission to access any services. Please contact your administrator to request access."
        extra={[
          <Button type="primary" key="contact" onClick={handleContactAdmin}>
            Contact Administrator
          </Button>,
          <Button key="logout" onClick={handleLogout}>
            Logout
          </Button>
        ]}
      />
    </div>
  );
};

export default NoAccess; 